<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
@if (!showConfirm) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Ændringer på vej</h1>
  <div mat-dialog-content class="flow mat-dialog-content--white">
    <app-upcoming-changes
      [serviceaftale]="serviceaftale"
      [upcomingChanges]="upcomingChanges"
      (onRemoveAbonnementChanges)="removeAbonnementChanges()"
      (onRemovePartnerChanges)="removePartnerChanges()"
    ></app-upcoming-changes>
  </div>
  <div mat-dialog-actions class="row-reverse align-center">
    <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
  </div>
} @else {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Fortryd ændringer</h1>
  <div mat-dialog-content>
    <div class="align-center med-text margin--bottom-l">
      @if (showConfirm === upcomingChangesTypeEnum.AbonnementAndTilvalg) {
        <h4 class="medium">Skal der sendes et brev til kunden om fortrydelse af ændringer?</h4>
        <app-send-letter
          [form]="sendLetterForm"
          [email]="$safeNavigationMigration(serviceaftale?.kunde?.anlaegsadresse?.email)"
          (reload)="reloadServiceAftale()"
        ></app-send-letter>
      }
      @if (showConfirm !== upcomingChangesTypeEnum.AbonnementAndTilvalg) {
        <h4 class="medium">Fortryd ændringer</h4>
      }
    </div>
    <button class="btn-close btn-icon" mat-dialog-close title="Luk dialog" (click)="cancel()">
      <mat-icon class="material-icons">close</mat-icon>
    </button>
  </div>
  <div mat-dialog-actions class="row-reverse align-center">
    <button mat-raised-button color="primary" (click)="confirm()" cdkFocusInitial>Fortryd ændringer</button>
    <button mat-raised-button (click)="cancel()">Annuller</button>
  </div>
}
